(function () {
  var el = document.getElementById('riwayat-intro');
  if (!el || el.hidden) return;
  if (!window.RIWAYAT || !window.RIWAYAT.introEnabled) {
    el.hidden = true;
    return;
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seenBefore = false;
  try {
    seenBefore = !!localStorage.getItem('riwayatIntroSeen');
  } catch (e) {}

  var skipBtn = el.querySelector('.riwayat-intro__skip');
  var configuredDuration = parseInt(el.getAttribute('data-duration'), 10);
  if (isNaN(configuredDuration) || configuredDuration <= 0) configuredDuration = 2600;
  var duration = reducedMotion ? 0 : seenBefore ? 900 : configuredDuration;

  function close() {
    el.hidden = true;
    try {
      sessionStorage.setItem('riwayatIntroShown', '1');
      localStorage.setItem('riwayatIntroSeen', String(Date.now()));
    } catch (e) {}
  }

  if (skipBtn) skipBtn.addEventListener('click', close);

  if (duration === 0) {
    close();
    return;
  }

  if (el.hasAttribute('data-no-ripple')) el.classList.add('riwayat-intro--no-ripple');
  if (seenBefore) el.classList.add('is-quick');
  el.classList.add('is-playing');

  window.setTimeout(close, duration);
})();
